package org.chiangmeng.qfast.core.ui.customer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import org.chiangmeng.qfast.core.ui.theme.QFastTheme

data class CustomerScreen(
    val shopId: String = "shop_001",
    val ticketNumber: String? = null
) : Screen {
    @Composable
    override fun Content() {
        val viewModel = koinScreenModel<CustomerViewModel>()
        val state by viewModel.state.collectAsState()

        DisposableEffect(shopId, ticketNumber) {
            viewModel.handleIntent(CustomerContract.Intent.LoadShop(shopId))
            if (!ticketNumber.isNullOrEmpty()) {
                viewModel.handleIntent(CustomerContract.Intent.UpdateTicketInput(ticketNumber))
            }
            onDispose {
                viewModel.handleIntent(CustomerContract.Intent.StopObserving)
            }
        }

        QFastTheme {
            CustomerWebScreen(
                state = state,
                onIntent = { intent ->
                    viewModel.handleIntent(intent)
                },
                autoConfirmed = !ticketNumber.isNullOrEmpty(),
                adBannerSlot = {}
            )
        }
    }
}
